import React from 'react';

const RetroBadge = ({ text, color = 'bg-retro-yellow', rotation = 'rotate-0', className = '' }) => {
  return (
    <div className={`inline-block border-4 border-retro-brown rounded-full px-6 py-2 font-display uppercase text-lg shadow-retro-sm ${color} ${rotation} ${className}`}>
      {text}
    </div>
  );
};

export default RetroBadge;